<template>
  <v-sheet class="service-details" :color="color" v-bind="$attrs">
    <h3 v-if="showTitle" class="service-details__title title">
      <slot name="title" :item="service">
        {{ $t('ORDERS.SERVICE_DETAILS') }}:
      </slot>
    </h3>

    <p class="service-details__item">
      <strong class="service-details__item-name"
        >{{ $t('SERVICES.ITEM') }}:</strong
      >
      <span>{{ service.title || '' }}</span>
    </p>
    <p class="service-details__item">
      <strong class="service-details__item-name">
        {{ $t('ORDERS.SERVICE_APP_NAME') }}:
      </strong>
      <span>{{ service.name || '' }}</span>
    </p>
  </v-sheet>
</template>

<script>
export default {
  name: 'OrderServiceDetails',

  props: {
    service: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: 'grey lighten-4'
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.service-details {
  & &__title,
  & &__item {
    display: block;
    margin-bottom: 1rem;
  }

  & &__item {
    font-size: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & &__item-name {
    margin-right: 0.4rem;
  }
}
</style>
